import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineArrowsVAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m10.21 6.21.79-.8V10a1.0001 1.0001 0 0 0 2 0V5.41l.79.8a1.001 1.001 0 0 0 .71.2958 1.0003 1.0003 0 0 0 .71-.2958 1.001 1.001 0 0 0 .2958-.71.9994.9994 0 0 0-.2958-.71l-2.5-2.5a.9994.9994 0 0 0-.33-.21 1 1 0 0 0-.76 0 1.0004 1.0004 0 0 0-.33.21l-2.5 2.5a1.0041 1.0041 0 0 0 1.42 1.42Zm3.58 11.58-.79.8V14a1.0003 1.0003 0 0 0-1-1 1.0001 1.0001 0 0 0-1 1v4.59l-.79-.8a1.0034 1.0034 0 0 0-1.42 0 1.0052 1.0052 0 0 0-.294.71 1.0045 1.0045 0 0 0 .294.71l2.5 2.5a.9996.9996 0 0 0 .33.21.94.94 0 0 0 .76 0 .9986.9986 0 0 0 .33-.21l2.5-2.5a1.0041 1.0041 0 1 0-1.42-1.42Z"/>
  </SvgIcon>
}

export default LineArrowsVAltIcon
